import type { FadeProps as _FadeProps } from "@chakra-ui/react";
import { forwardRef, Fade as _Fade } from "@chakra-ui/react";

export const Fade = forwardRef<_FadeProps, "div">(({ ...props }, ref) => (
    <_Fade ref={ref} {...props} />
));
